import { Link } from '@inertiajs/react'
import { cn } from '@/lib/utils'

interface GhostSectionProps {
  variant: 'actionable' | 'comingSoon'
  title: string
  hint: string
  compact?: boolean
  /** On the profile rail (bg-sidebar) dashed edges take the tinted border. */
  onRail?: boolean
  className?: string
}

export function GhostSection({ variant, title, hint, compact = false, onRail = false, className }: GhostSectionProps) {
  return (
    <div
      className={cn(
        'rounded-card border border-dashed',
        onRail ? 'border-sidebar-border' : 'border-border',
        compact ? 'p-4' : 'p-[18px]',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        {compact ? (
          <p className="font-mono text-[11px] uppercase tracking-eyebrow text-muted-foreground">
            {title}
          </p>
        ) : (
          <p className="font-heading text-[17px] font-bold text-muted-foreground">{title}</p>
        )}
        {variant === 'comingSoon' && (
          <span
            className={cn(
              'shrink-0 rounded-full border border-dashed px-[10px] py-[4px] font-mono text-[10px] uppercase tracking-[0.08em] text-muted-foreground',
              onRail ? 'border-sidebar-border' : 'border-border',
            )}
          >
            Coming soon
          </span>
        )}
      </div>
      <p className="mt-[6px] font-sans text-[13px] leading-[1.5] text-muted-foreground">{hint}</p>
      {variant === 'actionable' && (
        <Link href="/connect" className="mt-[10px] inline-block font-mono text-[12px] text-primary">
          Connect your agent <span aria-hidden="true">→</span>
        </Link>
      )}
    </div>
  )
}
